import { render, staticRenderFns } from "./PopularQuestions.vue?vue&type=template&id=12a32735&"
import script from "./PopularQuestions.vue?vue&type=script&lang=js&"
export * from "./PopularQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports